import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Box } from 'foundations-components/transitional/components/Box';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Image } from 'foundations-components/transitional/components/Image';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { H1 } from 'foundations-components/transitional/components/H1';
import { ACADEMY_PAGE_MAX_WIDTH, useMediaQuery } from '../../utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const COURSE_KEYS = {
  heading: 'academyCommon.errors.retiredContent.heading.course',
  message: {
    default: 'academyCommon.errors.retiredContent.message.course.default',
    withTitle: 'academyCommon.errors.retiredContent.message.course.withTitle'
  },
  button: 'academyCommon.errors.retiredContent.button.course'
};
const LESSON_KEYS = {
  heading: 'academyCommon.errors.retiredContent.heading.lesson',
  message: {
    default: 'academyCommon.errors.retiredContent.message.lesson.default',
    withTitle: 'academyCommon.errors.retiredContent.message.lesson.withTitle'
  },
  button: 'academyCommon.errors.retiredContent.button.lesson'
};
const VIDEO_KEYS = {
  heading: 'academyCommon.errors.retiredContent.heading.video',
  message: {
    default: 'academyCommon.errors.retiredContent.message.video.default',
    withTitle: 'academyCommon.errors.retiredContent.message.video.withTitle'
  },
  button: 'academyCommon.errors.retiredContent.button.video'
};
const CONTENT_KEYS = {
  heading: 'academyCommon.errors.retiredContent.heading.content',
  message: {
    default: 'academyCommon.errors.retiredContent.message.content.default',
    withTitle: 'academyCommon.errors.retiredContent.message.content.withTitle'
  },
  button: 'academyCommon.errors.retiredContent.button.content'
};
const I18N_KEYS = {
  TRACK: COURSE_KEYS,
  COURSE: COURSE_KEYS,
  LESSON: LESSON_KEYS,
  SHORT_FORM_CONTENT: VIDEO_KEYS,
  content: CONTENT_KEYS
};
const getI18nKeys = contentType => {
  var _I18N_KEYS;
  return (_I18N_KEYS = I18N_KEYS[contentType !== null && contentType !== void 0 ? contentType : 'content']) !== null && _I18N_KEYS !== void 0 ? _I18N_KEYS : I18N_KEYS.content;
};
const ACRetiredContentError = ({
  'data-test-id': dataTestId = 'retired-content-error',
  contentType,
  contentTitle,
  catalogRoute = 'results',
  illustrationSrc
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const i18nKeys = getI18nKeys(contentType);
  const getCatalogUrl = () => {
    const urlParams = new URLSearchParams();
    const targetContentType = contentType || 'COURSE';
    urlParams.set('contentType', targetContentType);
    if (targetContentType === 'COURSE') {
      urlParams.set('awardType', 'ONLY_SHOW_CERTIFICATE_COURSES');
    }
    const search = urlParams.toString().replace(/\+/g, '%20');
    return {
      pathname: `/${catalogRoute}`,
      search: search ? `?${search}` : ''
    };
  };
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": dataTestId,
    paddingBlockStart: isMobile ? '1100' : '1400',
    children: /*#__PURE__*/_jsx(View, {
      marginInline: "auto",
      maxInlineSize: `${ACADEMY_PAGE_MAX_WIDTH}px`,
      paddingInline: isMobile ? '400' : '1000',
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: "space-around",
        children: [/*#__PURE__*/_jsxs(View, {
          flex: 1,
          maxInlineSize: "500px",
          minInlineSize: "0",
          children: [/*#__PURE__*/_jsx(H1, {
            textAlign: "start",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKeys.heading
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            marginBlockStart: "400",
            textAlign: "start",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: contentTitle ? i18nKeys.message.withTitle : i18nKeys.message.default,
              options: {
                contentTitle
              }
            })
          }), /*#__PURE__*/_jsx(RouterButton, {
            marginBlockStart: "600",
            to: getCatalogUrl(),
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKeys.button
            })
          })]
        }), !isMobile && /*#__PURE__*/_jsx(Box, {
          flexShrink: 0,
          children: illustrationSrc ? /*#__PURE__*/_jsx(Image, {
            alt: "Retired content illustration",
            inlineSize: "280px",
            src: illustrationSrc
          }) : /*#__PURE__*/_jsx(Illustration, {
            alt: "Retired content illustration",
            inlineSize: "240px",
            name: "categories-color"
          })
        })]
      })
    })
  });
};
export default ACRetiredContentError;